function fetchSubmissionGalleryRequest({ dogId } = {}) {
  const config = window.pawPrintConfig || {};
  const { submissionGalleryUrl, submissionGalleryAuth } = config;
  const endpoint = `${submissionGalleryUrl}?dog_id=${encodeURIComponent(dogId || '')}`;

  return fetch(endpoint, {
    method: 'GET',
    headers: {
      auth: submissionGalleryAuth,
    },
  });
}

window.fetchSubmissionGalleryRequest = fetchSubmissionGalleryRequest;
